import {
  Component,
  Input,
  ViewChild,
} from '@angular/core';
import { DetailCardComponentData } from '../datos-mi-empresa-container/datos-mi-empresa-container.component';
import { DireccionesGeograficasFormComponent } from '../../../../ubicaciones/direcciones-geograficas/direcciones-geograficas-form/direcciones-geograficas-form.component';
import { DireccionGeografica } from '../../../../ubicaciones/direcciones-geograficas/direcciones-geografica.model';
import { Position } from 'projects/registro-personas-empresas/src/app/gis/gis.model';

@Component({
  selector: 'rpe-entity-mis-empresas-datos-detail',
  templateUrl: './entity-mis-empresas-datos-detail.component.html',
  styleUrls: ['./entity-mis-empresas-datos-detail.component.scss'],
})
export class EntityMisEmpresasDatosDetailComponent {

  @ViewChild('direccion')
  direccion: DireccionesGeograficasFormComponent

  @ViewChild('direccionChildren')
  direccionChildren: DireccionesGeograficasFormComponent

  @Input() dataOption: DetailCardComponentData[] = [];
  @Input() title: string = '';

  direccionGeografica: DireccionGeografica = null
  expandedChildren: { [key: string]: boolean } = {};


  get position(): Position {
    return {
      latitud: this.direccionGeografica?.latitud,
      longitud: this.direccionGeografica?.longitud
    }
  }

  getPositionByDireccionGeografica(dg: DireccionGeografica): Position {
    return {
      latitud: dg.latitud,
      longitud: dg.longitud,
    }
  }

  getSplit(value: string): string[] {
    if (!value) {
      return [];
    }

    return value.split(';');
  }

  formatBoldText(item: string): string {
    return item.replace(
      /Especie: (.+?)\. Análisis: (.+?)$/g,
      '<strong>Especie:</strong> $1. <strong>Análisis:</strong> $2'
    );
  }

  getLabelToShow(label: string): boolean {
    return (
      // label === 'Especies y análisis' ||
      label === 'Equipamientos' ||
      label === 'Especies' ||
      label === 'Divisores de Muestra' ||
      label === 'Laboratorios'
    );
  }

    toggle(parentIndex: number, childIndex: number) {
    const key = `${parentIndex}-${childIndex}`;
    this.expandedChildren[key] = !this.expandedChildren[key];
  }
  
  isChildExpanded(parentIndex: number, childIndex: number): boolean {
    const key = `${parentIndex}-${childIndex}`;
    return this.expandedChildren[key];
  }
}
